const CustomLinkRenderer = ({ href, children }) => (
  <a href={href} target="_blank">
    {children}
  </a>
);

export default CustomLinkRenderer;
